<template>
  <div class="column">
    <div class="title">Filtros</div>
    <section class="row">
      <div
        class="col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold filtro-unidade"
      >
        Unidade:
        <lista-unidades-select
          :todos="true"
          v-model="filtros.unidade"
        ></lista-unidades-select>
      </div>
      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold filtro-regiao"
      >
        Região:
        <q-input dense outlined v-model="filtros.regiao" />
      </div>

      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Data Inicial:

        <q-input
          class="col input"
          dense
          outlined
          placeholder="DD/MM/AAAA"
          v-model="filtros.inicial"
          mask="##/##/####"
          :rules="[
            (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  :options="optionsFn"
                  mask="DD/MM/YYYY"
                  v-model="filtros.inicial"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Data Final:

        <q-input
          class="col input"
          dense
          outlined
          placeholder="DD/MM/AAAA"
          v-model="filtros.final"
          mask="##/##/####"
          :rules="[
            (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  :options="optionsFn"
                  mask="DD/MM/YYYY"
                  v-model="filtros.final"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Produto:
        <q-input dense outlined v-model="filtros.produto" />
      </div>
    </section>
    <section class="row q-mt-sm">
      <div class="col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold">
        Solicitante:
        <q-input dense outlined v-model="filtros.solicitante" />
      </div>
      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Centro de Custo:
        <q-input dense outlined v-model="filtros.centro" />
      </div>
      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Tipo de Material:

        <q-select :options="tipos" v-model="filtros.material" dense outlined />
      </div>
      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        ID Requisição:

        <q-input
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          dense
          outlined
          v-model="filtros.id"
        />
      </div>
      <div
        class="q-ml-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Codigo Categoria:

        <q-input dense outlined v-model="filtros.categoria_produto_codigo" />
      </div>
      <div
        class="q-mt-sm col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Grupo Produto:

        <q-input dense outlined v-model="filtros.grupo_produto_nome" />
      </div>
      <div class="q-mt-sm col-md-2 col-sm-12 col-xs-12 flex items-end q-ml-sm">
        <q-btn
          style="margin-bottom: 3px"
          label="Aplicar filtros"
          color="primary"
          icon="filter_alt"
          no-caps
          @click="aplicarFiltros"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { useStore } from "vuex";
export default {
  components: { ListaUnidadesSelect },
  setup(props, { emit }) {
    const filtros = ref({
      regiao: "",
      produto: "",
      inicial: "",
      final: "",
      unidade: "",
      solicitante: "",
      centro: "",
      material: "",
      id: "",
      categoria_produto_codigo: "",
      grupo_produto_nome: "",
    });
    const store = useStore();

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      filtros.value.unidade = store.state.org.unidadeData;
    };
    onMounted(getUnidade);

    const aplicarFiltros = () => {
      if (filtros.value.inicial != "" && filtros.value.inicial.length != 10) {
        return;
      }
      if (filtros.value.final != "" && filtros.value.final.length != 10) {
        return;
      }
      emit("emitirFiltros", filtros.value);
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidade = store.state.org.unidadeData;
      }
    );

    return {
      filtros,
      aplicarFiltros,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      optionsFn(date) {
        var hoje = new Date();

        var ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());

        var dd = ontem.getDate();
        var mm = ontem.getMonth() + 1;
        var yyyy = ontem.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }

        var data_ok = yyyy + "/" + mm + "/" + dd;

        return date <= data_ok;
      },
      tipos: [
        { label: "SOMENTE EPI", value: "sim" },
        { label: "SOMENTE NÃO EPI", value: "nao" },
        { label: "TODOS", value: "todos" },
      ],
    };
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 15px;
  font-size: 1.25rem;
  margin-top: 20px;
}

@media (max-width: 600px) {
  .title {
    font-size: 1.2rem !important;
    text-align: center;
    margin-bottom: 16px;
  }

  .row {
    flex-direction: column !important;
  }

  .col-md-2 {
    width: 100% !important;
    margin: 0 0 16px 0 !important;
    padding: 0 !important;
  }

  .filtro-regiao {
    margin-top: 10px !important;
  }

  .q-ml-sm {
    margin-left: 0 !important;
  }

  .q-mt-sm {
    margin-top: 0 !important;
  }

  .col-md-2 .q-field {
    width: 100% !important;
  }

  .col-md-2 .q-select {
    width: 100% !important;
  }

  .col-md-2 .q-input {
    width: 100% !important;
  }

  .col.input {
    width: 100% !important;
  }
}
</style>

<style>
@media (max-width: 600px) {
  .filtro-unidade lista-unidades-select {
    display: block !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .filtro-unidade lista-unidades-select * {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .filtro-unidade .mobileUnidade {
    margin-left: 0 !important;
  }
}
</style>
